module.exports = __webpack_public_path__ + "assets/img/ic-marquee.210e8b28.svg";